import React, { Component,useEffect,useState } from "react";
import LastNews from "./lastnews";
import { Link } from 'react-router-dom';

class Yearlyreport extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="yearlyreport" className="a-breadcrumbs">รายงานประจำปี</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>รายงานประจำปีสหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <a href="Form/YearlyReport/รายงานประจำปี2568.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2568</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2567.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2567</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2566.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2566</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2565.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2565</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2564.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2564</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2563.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2563</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2562.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2562</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2561.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2561</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2560.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2560</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2559.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2559</a><br />
                <br />
                <a href="Form/YearlyReport/รายงานประจำปี2558.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>รายงานประจำปี 2558</a><br />
              </div>

              <LastNews />
              
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Yearlyreport;
